const fees = {
  shipping: { value: 'Shipping', label: 'Shipping' },
  handling: { value: 'Handling', label: 'Handling' },
};

export default fees;
